<style lang='less'>
    .cloudIndex{
        width: 1440px;
        margin: 0 auto;
        padding-top: 70px;
        .topBg{
            width: 100%;
            height: 195px;
            padding: 45px 210px;
            color: #fff;
            position: relative;
            .content{
                p{
                    text-align: left;
                    font-size: 24px;
                    &:nth-of-type(1){
                        font-size: 18px;
                        padding-bottom: 13px;
                        border-bottom: 1px solid #fff;
                        width: 202px;
                        margin-bottom: 16px;
                    }
                }
            }
            .index_imgBox{
                position: absolute;
                right: 191px;
                top: 9px !important;
                width: 390px;
                height: 225px;
            }
        }
        .midBg{
            margin-top: 40px;
            .indexImgBox{
                margin-top: 20px;
                width: 100%;
                height: 348px;
                padding-top: 42px;
                >div{
                    margin: 0 auto;
                    &:nth-of-type(1){
                        width:300px;
                        height:42px;
                        background:rgba(180,139,89,1);
                        border-radius:45px;
                        line-height: 42px;
                        text-align: center;
                        color: #fff;
                        font-size: 24px;
                        span{
                            font-size: 32px;
                        }
                    }
                     &:nth-of-type(2){
                         margin-top: 43px;
                         display: flex;
                         justify-content: space-between;
                         width: 562px;
                         font-size: 22px;
                         color: #fff;
                         ul{
                             li{
                                margin-bottom: 28px;
                             }
                         }
                     }
                }
            }
        }
        .vip_cards{
            width: 1440px;
            height: 330px;
            z-index: 2;
            display: flex;
            justify-content: space-between;
            margin-top: 40px;
            >div{
                width: 680px;
                height: 330px;
                padding: 27px 80px;
                text-align: left;
                color: #484848;
                position: relative;
                p{
                    font-size: 20px;
                    span{
                        font-size: 26px;
                        font-weight: bold;
                        display: inline-block;
                        margin-right: 13px;
                    }
                }
                ul{
                    font-size: 22px;
                    margin-top: 34px;
                    li{
                        padding: 6px 0;
                    }
                }
                >div{
                    position: absolute;
                    right: 40px;
                    bottom: 30px;
                    font-size: 24px;
                    display: flex;
                    align-items: center;
                    span{
                        display: inline-block;
                        margin-left: 8px;
                    }
                }
            }
        }
    }
</style>
<template>
    <div class="cloudIndex">
        <div class="topBg" :style="{background:'url('+topBg+')'}">
            <div class="content">
                <p>全国3大总仓，2大海外仓</p>
                <p>集中采购，集中售后，就近配送</p>
            </div>
            <div class="index_imgBox"><img src="../../assets/index_bg3.png" alt=""></div>
        </div>
        <div class="midBg">
            <div><img width="226" height="25" src="../../assets/title_index.png" alt=""></div>
            <div class="indexImgBox" :style="{background:'url('+midBg+')'}">
                <div>云仓会员，<span>6</span>大尊享服务</div>
                <div>
                    <ul>
                        <li>1.会员价格，品质保障</li>
                        <li>2.售后担保，发货保障</li>
                        <li>3.信用良好，可以赊账</li>
                    </ul>
                    <ul>
                        <li>4.材料设备，配套齐全</li>
                        <li>5.色卡画册，辅助营销</li>
                        <li>6.新厂帮扶，定制采购</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="vip_cards">
            <div v-for="item in cards" :key="item.id" :style="{background:'url('+item.bg+')',color:item.color}">
                <p style="color:#E62800;font-weight:bold;"><span :style="{color:item.color}">{{item.title}}</span>￥{{item.price}}</p>
                <span v-if="item.goHome">{{item.goHome}}</span>
                <ul :style="{marginTop:item.goHome?'20px':'40px'}">
                    <li v-for="(value,index) in item.include" :key="index">{{index+1}}.{{value}}</li>
                </ul>
                <div class="cursor" @click="BuyVip(item.id)"><img :src="item.buyBtn" alt=""><span>加入会员</span></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data(){
        return{
            topBg:require('../../assets/index_bg1.png'),
            midBg:require('../../assets/index_bg2.png'),
            cards:[
                {
                    id:21,
					title:"银牌会员",
                    price:"1000",
                    goHome:'',
					exp:"终生",
					include:["价值￥980《柜柜木工版》软件","实物色卡+实物画册","价值￥1000柜柜模型，快速下单"],
					color:"#484848",
					bg:require('../../assets/ying.png'),
					buyBtn:require('../../assets/wood_buy.png')
                },
                {
					id:22,
					title:"金牌会员",
                    price:"5000",
                    goHome:'技术专家上门服务',
					exp:"终生",
					include:["价值￥3980《柜柜门店版》软件","实物色卡+实物画册","价值￥1000柜柜模型，快速下单",'色板展架+板材30*40样品','材料款抵用劵5000元'],
					color:"#674302",
					bg:require('../../assets/gold_pc.png'),
					buyBtn:require('../../assets/design_buy.png')
				}

            ],
        }
    },
    computed: {
        ...mapState({
            userData: 'userInfo'
        }),
    },
    mounted(){
        this.$get('/guigui/price/getAppPrice',{},res => {
            let price=res.data
            for(let i = 0,len=price.length;i<len;i++){
                if(price[i].id==21){
                    this.cards[0].price=price[i].price
                    this.cards[0].exp=price[i].unit
                }
                if(price[i].id==22){
                    this.cards[1].price=price[i].price
                    this.cards[1].exp=price[i].unit
                }
            }
        })
        
    }, 
    methods:{
        BuyVip(cardId){
            let id = cardId
            if(!localStorage.data){
                let pageTo=encodeURIComponent(location.href)
                location.href = 'https://www.guigui.com.cn/login.html?other=true&pageTo=' + pageTo
            }
            if(this.userData){
                this.$emit('changeNow','加入云仓')
            }
        }
    }
}
</script>